import React from "react";

const ARIA_SORT = { 1: "ascending", "-1": "descending" };

/**
 * Header of a sortable table: every column is a button and its `th` carries `aria-sort`. Controlled:
 * the screen owns the sort state (see `nextSort` in statsSort.js).
 *
 * @param {{columns: Array<{key: string, label: string, numeric: boolean}>, sort: {key: string, dir: 1|-1},
 *   onSort: (key: string) => void}} props
 */
export function SortableHead({ columns, sort, onSort }) {
  return (
    <thead>
      <tr>
        {columns.map((column) => {
          const active = sort.key === column.key;
          return (
            <th key={column.key} className={column.numeric ? "num" : undefined} aria-sort={active ? ARIA_SORT[sort.dir] : "none"}>
              <button type="button" className="stats-sort-btn" onClick={() => onSort(column.key)}>
                {column.label}
                <span className={`stats-sort-arrow${active ? " is-active" : ""}`} aria-hidden="true">
                  {active && sort.dir > 0 ? "▲" : "▼"}
                </span>
              </button>
            </th>
          );
        })}
      </tr>
    </thead>
  );
}

// Occupancy as a bar fill, rounded to a tenth of a point.
const meterWidth = (occupancy) => `${Math.round(Math.max(0, Math.min(1, occupancy)) * 1000) / 10}%`;

/**
 * A percentage with a small track under it. `children` is the formatted text; an unknown occupancy
 * (null) shows an empty track.
 * @param {{value: number|null, children: React.ReactNode}} props
 */
export function Meter({ value, children }) {
  return (
    <span className="stats-meter">
      <span>{children}</span>
      <span className="stats-meter__track" aria-hidden="true">
        {value !== null && value !== undefined && <span className="stats-meter__fill" style={{ width: meterWidth(value) }} />}
      </span>
    </span>
  );
}
